import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeSpec } from './NodeSpec';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const textNodeSpec: NodeSpec<NodeCfg<'text'>> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: { value: '' }, id: getUID(), kind: 'text', disabled: false }),
    controls: nodeCfg => ({
        value: defineControlOpts({ cfg: { kind: 'text', placeholder: 'Enter a text value' }, on: { 'update:value': defaultControlUpdateValueHandler }, value: nodeCfg.controlValues.value }),
    }),
    inputs: () => ({}),
    kindLabel: 'Text',
    nodeCategory: 'text',
    outputs: () => ({ output: { socket: 'string', label: 'Output' } }),
    validator: () => true,
};
